import './MobileOptionsMenu.scss';

import {MoreOutlined} from '@ant-design/icons';
import {Dropdown} from 'antd';
import cn from 'classnames';
import React, {useState} from 'react';

import useActionConfirmPopup from '../../hooks/useActionConfirmPopup';

const MobileOptionsMenu = ({menuItems, label, disabled, customTrigger, triggerClassName, overlayClassName}) => {
    const [isOpen, setIsOpen] = useState(false);
    const actions = useActionConfirmPopup(menuItems);
    const trigger = customTrigger || (
        <button type='button' aria-label={label}>
            <MoreOutlined aria-hidden />
        </button>
    );
    const items = actions.map(({key, label, icon, danger, onClick}) => ({
        key,
        label,
        icon,
        danger,
        onClick: (event) => {
            event.domEvent.stopPropagation();
            setIsOpen(false);
            onClick?.();
        },
    }));

    return (
        <Dropdown
            open={isOpen}
            onOpenChange={setIsOpen}
            disabled={disabled}
            trigger={['click']}
            placement='bottomRight'
            overlayClassName={cn('mobile-options-menu', overlayClassName)}
            menu={{items, selectable: false}}
            autoFocus
        >
            {React.cloneElement(trigger, {
                className: cn(trigger.props.className, 'mobile-options-trigger', triggerClassName),
                disabled,
                'aria-haspopup': 'menu',
                'aria-expanded': isOpen,
            })}
        </Dropdown>
    );
};

export default MobileOptionsMenu;
